import React from "react"

const style = {
    height: '40px',
    width: '150px'
};

const Donate = () => {
    return (
        <div>
            <a href="https://www.buymeacoffee.com/stebakerdev" target="_blank" rel="noreferrer"><img src="https://cdn.buymeacoffee.com/buttons/v2/default-black.png" alt="Buy Me A Coffee" style={style} / ></a>
        </div>
    )
}

export default Donate
